import React from 'react';
import {reduxForm} from 'redux-form';
import ImageField from '../form/image-field';
import BaseForm from '../form/base-form';
import LocalizedStrings from '../../localization/strings';
import FormField from '../form/form-field';
import Alert from '../alert';

const fields = ['imageId'];

function validate() {
    return [];
}
class ImageForm extends BaseForm {
    render() {
        const { error, handleSubmit, fields: {
                imageId
            }} = this.props;
        return (
            <div>
                <form onSubmit={handleSubmit(this.submit.bind(this))}>
                    {error && <Alert type="error">{error}</Alert>}

                    <FormField label={LocalizedStrings.image} name="image" field={imageId}>
                        <ImageField {...imageId} onImageUploaded={this.props.onImageUploaded}></ImageField>
                    </FormField>

                </form>
            </div>
        )
    }
}

export default reduxForm({form: 'image-form', fields, validate, destroyOnUnmount: true})(ImageForm);



// WEBPACK FOOTER //
// ./src/js/components/image/image-form.js